import Chronometer from 'app/components/Chronometer'
import { format } from 'date-fns'

const StartedFinished = ({ dodone }) => {
  if(!dodone.startedAt || !dodone.finishedAt) return null

  return <div className="text-2xs digital-display frow gap-2 items-center">
           { format(dodone.startedAt, 'HH:mm') }
           <i className="ph ph-arrow-right" />
           { format(dodone.finishedAt, 'HH:mm') }
         </div>
}

export default ({ prefix, dodone }) => {
  const Element = dodone.id ? Link : 'div'
  // const Element = Link // Test style without a hassle

  return <Element to={ `/dodones/${dodone.id}` } className={ `dodone-list-item dodone-list-item-${dodone.status}` }>
           <div className="dodone-list-item-content">
             { prefix ? <div className="dodone-list-item-content-prefix"> { prefix } </div> : null }
             <div className="dodone-list-item-text"> { dodone.listItemText } </div>
             { dodone.isOngoing && <Chronometer startedAt={ dodone.startedAt } size={ 'extra-small' } /> }
             <StartedFinished dodone={ dodone } />
           </div>
           <div className='dodone-list-item-icon-wrapper'>
             <i className="dodone-list-item-icon"></i>
           </div>
         </Element>
}
